import { render } from "./TextareaInput.vue?vue&type=template&id=1c319b86"
import script from "./TextareaInput.vue?vue&type=script&lang=js"
export * from "./TextareaInput.vue?vue&type=script&lang=js"
script.render = render

export default script